function initMenuA11y() {
  const toggle = document.querySelector('.menu[data-modal-nav-toggle][aria-controls="page-menu"]');
  const nav = document.getElementById('page-menu');
  if (!toggle || !nav) return;

  if (nav.dataset.a11yInit === 'true') return;
  nav.dataset.a11yInit = 'true';

  // Ensure toggle has aria-expanded
  if (!toggle.hasAttribute('aria-expanded')) toggle.setAttribute('aria-expanded', 'false');

  // --- SYNC WITH THEME, DON'T OVERRIDE ---
  function isThemeOpen() {
    const expanded   = toggle.getAttribute('aria-expanded') === 'true';
    const byClass    = nav.classList.contains('is-open') || nav.classList.contains('open') || nav.classList.contains('active');
    const byBody     = document.body.classList.contains('nav-open') || document.documentElement.classList.contains('nav-open');
    return expanded || byClass || byBody;
  }
  function syncHidden() {
    if (isThemeOpen()) {
      nav.removeAttribute('hidden');
      // move focus to first item only the first time after opening
      if (!nav.dataset.a11yFocused) {
        const firstItem = nav.querySelector('.nav.main-nav [role="menuitem"], .nav.main-nav a, .nav.main-nav button');
        if (firstItem) firstItem.focus();
        nav.dataset.a11yFocused = 'true';
      }
    } else {
      nav.setAttribute('hidden', '');
      toggle.focus();
      nav.dataset.a11yFocused = '';
      // close any open submenus
      submenuToggles.forEach(closeSubmenu);
    }
  }

  // Run once and observe theme changes
  syncHidden();
  new MutationObserver(syncHidden).observe(toggle, { attributes: true, attributeFilter: ['aria-expanded', 'class'] });
  new MutationObserver(syncHidden).observe(nav,    { attributes: true, attributeFilter: ['class'] });

  // After a theme-handled click, resync (letting theme update first)
  toggle.addEventListener('click', () => setTimeout(syncHidden, 0));

  // Close with Esc anywhere inside the drawer
  nav.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      // let theme close it (typically toggles aria-expanded/classes)
      // We try to flip aria-expanded; theme handlers usually listen to the click,
      // so dispatch a click on the toggle for compatibility.
      toggle.click();
    }
  });

  // ——— Submenus ———
  const submenuToggles = Array.from(nav.querySelectorAll('a[aria-haspopup="true"], button[aria-haspopup="true"]'));

  function getSubmenu(btn) {
    const li = btn.closest('li');
    if (!li) return null;
    return li.querySelector(':scope > ul');
  }
  function openSubmenu(btn) {
    const menu = getSubmenu(btn);
    if (!menu) return;
    btn.setAttribute('aria-expanded', 'true');
    menu.removeAttribute('hidden');
  }
  function closeSubmenu(btn) {
    const menu = getSubmenu(btn);
    if (!menu) return;
    btn.setAttribute('aria-expanded', 'false');
    menu.setAttribute('hidden', '');
  }

  // Initialize submenu states
  submenuToggles.forEach((btn) => {
    if (!btn.hasAttribute('aria-expanded')) btn.setAttribute('aria-expanded', 'false');
    const menu = getSubmenu(btn);
    if (menu && !menu.hasAttribute('hidden')) menu.setAttribute('hidden', '');

    // Click to toggle (prevent navigation if <a> has children)
    btn.addEventListener('click', (e) => {
      if (btn.tagName === 'A') e.preventDefault();
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      const siblings = btn.closest('ul')?.querySelectorAll('a[aria-haspopup="true"], button[aria-haspopup="true"]') || [];
      siblings.forEach((sib) => { if (sib !== btn) closeSubmenu(sib); });
      expanded ? closeSubmenu(btn) : openSubmenu(btn);
    });

    // Keyboard support
    btn.addEventListener('keydown', (e) => {
      const topItems = Array.from(nav.querySelectorAll('.nav.main-nav > ul > li > a, .nav.main-nav > ul > li > button'));
      const idx = topItems.indexOf(btn);
      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault();
          openSubmenu(btn);
          const firstSub = getSubmenu(btn)?.querySelector('a, button, [role="menuitem"]');
          if (firstSub) firstSub.focus();
          break;
        case 'ArrowRight':
          if (idx > -1) { e.preventDefault(); topItems[(idx + 1) % topItems.length]?.focus(); }
          break;
        case 'ArrowLeft':
          if (idx > -1) { e.preventDefault(); topItems[(idx - 1 + topItems.length) % topItems.length]?.focus(); }
          break;
        case 'Escape':
          e.preventDefault();
          closeSubmenu(btn);
          btn.focus();
          break;
      }
    });
  });

  // Inside submenu: up/down + Esc/Left back to parent toggle
  nav.addEventListener('keydown', (e) => {
    const item = e.target.closest('a, button, [role="menuitem"]');
    const submenu = e.target.closest('ul');
    if (!item || !submenu || submenu.closest('#page-menu') == null) return;

    const items = Array.from(submenu.querySelectorAll('a, button, [role="menuitem"]'));
    const i = items.indexOf(item);

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      items[(i + 1) % items.length].focus();
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      items[(i - 1 + items.length) % items.length].focus();
    } else if (e.key === 'Escape' || e.key === 'ArrowLeft') {
      e.preventDefault();
      const parentToggle = item.closest('ul')?.parentElement?.querySelector(':scope > a[aria-haspopup="true"], :scope > button[aria-haspopup="true"]');
      if (parentToggle) {
        closeSubmenu(parentToggle);
        parentToggle.focus();
      }
    }
  });

  // Click outside closes (delegate to theme via toggle click)
  document.addEventListener('click', (e) => {
    if (!nav.contains(e.target) && e.target !== toggle && isThemeOpen()) {
      toggle.click();
    }
  });
}
